import * as React from 'react'

import type { VariantProps } from '@config/tailwind/cva'
import cn from '@config/tailwind/cn'
import { cva } from '@config/tailwind/cva'

import { typographyVariants } from '../lib/typography'

const alertVariants = cva(
  'ui:relative ui:w-full ui:rounded-xl ui:border ui:px-4 ui:py-3 ui:grid ui:has-[>svg]:grid-cols-[calc(var(--spacing)*5)_1fr] ui:grid-cols-[0_1fr] ui:has-[>svg]:gap-x-3 ui:gap-y-1 ui:items-start ui:[&>svg]:size-5 ui:[&>svg]:translate-y-0.5 ui:[&>svg]:text-current',
  {
    variants: {
      variant: {
        neutral: 'ui:bg-navy-20 ui:border-navy-80 ui:text-navy-100',
        success: 'ui:bg-blue-20 ui:border-blue-50 ui:text-navy-80',
        error: 'ui:bg-error-container ui:border-error ui:text-error',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
)

function Alert({ className, variant, ...props }: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div data-slot='alert' role='alert' className={cn(alertVariants({ variant }), className)} {...props} />
}

function AlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='alert-title'
      className={cn(typographyVariants({ variant: 'body-md' }), 'ui:col-start-2 ui:font-semibold', className)}
      {...props}
    />
  )
}

function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='alert-description'
      className={cn(typographyVariants({ variant: 'body-md' }), 'ui:col-start-2 ui:[&_p]:leading-relaxed', className)}
      {...props}
    />
  )
}

export { Alert, AlertTitle, AlertDescription, alertVariants }
